var PROXY_METHODS = [
    'send',
    'forceSend',
    'updateUserProperties',
    'updateFeatureFlags',
    'updateABGroups',
    'updateClientParameters',
    'off',
    'on',
    'fork',
];
var isProxyClientMethod = function (prop) {
    return typeof prop === 'string' && PROXY_METHODS.includes(prop);
};
export var createProxy = function (instancePromise) {
    var realInstance = null;
    instancePromise
        .then(function (instance) {
        realInstance = instance;
    })
        .catch(function () { });
    return new Proxy({
        get instance() {
            return realInstance;
        },
        instancePromise: instancePromise,
    }, {
        get: function (target, prop) {
            if (realInstance && prop in realInstance) {
                return realInstance[prop];
            }
            if (isProxyClientMethod(prop)) {
                if (prop === 'fork') {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return createProxy(instancePromise.then(function (client) { return client.fork.apply(client, args); }));
                    };
                }
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    instancePromise
                        .then(function (client) {
                        client[prop].apply(client, args);
                    })
                        .catch(function () { });
                };
            }
            return target[prop];
        },
    });
};
//# sourceMappingURL=create-proxy.js.map